// extracted by mini-css-extract-plugin
export default {"masonry":"masonry__pC401"};